<template>
  <v-container fluid>
    <v-data-table
      v-for="(item, index) in summaries"
      :key="index"
      :headers="summariesTableHeaders"
      :items="[item]"
      class="elevation-1 mb-12 table"
      :loading="loadingTable"
      hide-default-footer
      item-key="key"
      fixed-header
      disable-filtering
      disable-pagination
      disable-sort
    >
      <template v-slot:top>
        <header class="table__header">
          <strong>
            {{ item.tenantFriendlyName }}
          </strong>
        </header>
      </template>

      <template v-slot:no-data>
        <v-btn
          color="primary"
          dark
          @click="getSummaries"
        >
          Refresh
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import {summariesTableHeaders} from "@/utils/staticTablesColumns";

export default {
  name: "Summaries",
  data() {
    return {
      loadingTable: false,
    }
  },
  computed: {
    ...mapGetters({
      summaries: 'AnalyzerStore/summaries'
    })
  },
  async created() {
    this.summariesTableHeaders = summariesTableHeaders;

    await this.getSummaries();
  },
  methods: {
    async getSummaries() {
      try {
        this.loadingTable = true;

        await this.$store
            .dispatch("AnalyzerStore/getSummaries");
      } finally {
        this.loadingTable = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .table {
  .table {
    &__header {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 16px;
      border-bottom: 2px solid rgba(0, 0, 0, 0.60);
    }
  }
}
</style>